import { logistica_GUIA_PROFORMA } from "@pcgerente-node/pcg-comun/dist/DTOs";
import { RowContenidoviewModel } from "../../ViewModels/RowContenidoviewModel";

export class logistica_GUIA_PROFORMALocal extends logistica_GUIA_PROFORMA{
    rowsContenidoParaCrear: RowContenidoviewModel[] = [
        new RowContenidoviewModel(),
        new RowContenidoviewModel(),
        new RowContenidoviewModel(),
        new RowContenidoviewModel(),
        new RowContenidoviewModel()
    ];
    valorDeclaradoString?:string;
}